export default "__VITE_ASSET__z0eXEs29__"